<template >
  <b-dropdown class="button is-cursor-default" @click="$refs.dropdownLegende.toggle()"
              position="is-bottom-left">
    <a slot="trigger">
      <b-icon icon="format-list-checkbox" size="is-small"  type="is-default"></b-icon>
      <span class="is-size-7">{{$t('reseauTempo.legende.title')}}</span>
    </a>
    <div class="width-340">
      <div class="pd-10px has-text-left notClickable mgt-10px">
        <div class="legende-square legende-square-bloqueCommande mgl-20px">
          <span class="mgl-40px has-text-weight-bold">
            {{ $t('reseauTempo.legende.bloqueCommande') }}
          </span>
        </div>
      </div>
      <hr class="mgl-20px mgr-20px">
      <div class="pd-10px has-text-left notClickable mgt-10px">
        <div class="legende-square legende-square-bloqueDevis mgl-20px">
          <span class="mgl-40px has-text-weight-bold">
            {{ $t('reseauTempo.legende.bloqueDevis') }}
          </span>
        </div>
      </div>
      <hr class="mgl-20px mgr-20px">
      <div class="pd-10px has-text-left notClickable mgt-10px">
        <div class="legende-square legende-square-option mgl-20px">
          <span class="mgl-40px has-text-weight-bold">
            {{ $t('reseauTempo.legende.option') }}
          </span>
        </div>
      </div>
      <hr class="mgl-20px mgr-20px">
      <div class="pd-10px has-text-left notClickable mgt-10px">
        <div class="legende-square legende-square-facture mgl-20px">
          <span class="mgl-40px has-text-weight-bold">
            {{ $t('reseauTempo.legende.facture') }}
          </span>
        </div>
      </div>
      <hr class="mgl-20px mgr-20px">
      <div class="pd-10px has-text-left notClickable mgt-10px">
        <div class="legende-square legende-square-enAttentRelanceOption mgl-20px">
          <span class="mgl-40px has-text-weight-bold">
            {{ $t('reseauTempo.legende.relanceOption') }}
          </span>
        </div>
      </div>
      <hr class="mgl-20px mgr-20px">
      <div class="pd-10px has-text-left notClickable mgt-10px mgb-10px">
        <div class="legende-square legende-square-libre mgl-20px">
          <span class="mgl-40px has-text-weight-bold">
            {{ $t('reseauTempo.legende.libre') }}
          </span>
        </div>
      </div>
      <hr class="mgl-20px mgr-20px">
      <div class="pd-10px has-text-left notClickable mgt-10px mgb-10px">
        <div class="legende-square mgl-20px">
          <b-icon  custom-class="height-100" class="mgl-2px"
                  type="is-link" icon="minus-circle" size="is-small">
          </b-icon>
          <span class="mgl-10px has-text-weight-bold">
            {{ $t('reseauTempo.nePasReafficher') }}
          </span>
        </div>
      </div>
    </div>
  </b-dropdown>
</template>

<script>
export default {
  name: 'legendeReseauTempo',
};
</script>

<style scoped>

</style>
